/**
 * BMAT Layout Module
 */
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { BMDurationInputComponent } from './bm-duration-input/bm-duration-input.component';
import { BMMultiselectComponent } from './bm-multiselect/bm-multiselect.component';
import { BMInputSearchComponent } from './bm-search-input/bm-input-search.component';
import {
  BMOptionDirective,
  BMSelectComponent,
} from './bm-select/bm-select.component';

@NgModule({
  imports: [CommonModule],
  declarations: [
    BMDurationInputComponent,
    BMInputSearchComponent,
    BMMultiselectComponent,
    BMOptionDirective,
    BMSelectComponent,
  ],
  exports: [
    BMDurationInputComponent,
    BMInputSearchComponent,
    BMMultiselectComponent,
    BMOptionDirective,
    BMSelectComponent,
  ],
  providers: [],
})
export class BMATFormsModule {}
